import { useReducer } from 'react';
import { AspectRatioName } from 'types';
import { VideoWizardObjective } from '../../types';
import reducer, { DEFAULT_STATE } from './reducer';

export type UseVideoFlowStateProps = {
  defaultAspectRatio?: AspectRatioName;
  defaultLanguage?: string;
  defaultObjective?: VideoWizardObjective;
  isAspectRatioLocked?: boolean;
};

export default function useVideoFlowState(props: UseVideoFlowStateProps) {
  return useReducer(reducer, {
    ...DEFAULT_STATE,
    aspectRatioName: props.defaultAspectRatio ?? DEFAULT_STATE.aspectRatioName,
    isAspectRatioLocked: !!props.isAspectRatioLocked,
    isObjectiveStepComplete: !!props.defaultObjective,
    language: props.defaultLanguage ?? DEFAULT_STATE.language,
    objective: props.defaultObjective ?? DEFAULT_STATE.objective,
  });
}
